/*
** Helper fns for the Help Icon pop-ups on the Customize Emails & Alerts screen
** includes a map of which image files to load
*/
import { isEmpty } from 'lodash'

const helpMap = {
  'folder': 'Email Preferences/',
  'weekly_forecast_changes': {
    image: 'WeeklyForecastChangesPopup.png',
    sample: 'IPD Analytics Weekly Forecast Changes.pdf'
  },
  'weekly_us_pharma_biotech_watch_list': {
    image: 'WeeklyUSPharmaBiotechWatchList.png',
    sample: 'IPD Analytics Weekly U.S. Pharma-Biotech Watch List.pdf'
  },
  'weekly_european_watch_list': {
    image: 'EUWatchList.png',
    sample: 'IPD Analytics Weekly European Watch List.pdf'
  },
  'weekly_med_tech_watch_list': {
    image: 'MedTechWatchList.png',
    sample: 'IPD Analytics Weekly Med-Tech Watch List.pdf'
  },
  'weekly_tech_media_watch_list': {
    image: 'TechMediaWatchList.png',
    sample: 'IPD Analytics Weekly Tech-Media Watch List.pdf'
  },
  'weekly_pharmacy_and_therapeutics_management_watch_list': {
    image: 'PTWatchList.png',
    sample: 'IPD Analytics Weekly Pharmacy and Therapeutics Management Watch List.pdf'
  },
  'codesourxce_monthly_change_report': {
    image: 'CODESOURxCEMonthlyChangeReportPOPUP.png',
    sample: 'IPD Analytics Monthly CODESOURxCE Change Report.pdf'
  },
  'weekly_eu_spc_tracker_status_change_report': {
    image: 'SPCTrackerLearnMore.png',
    sample: 'IPD Analytics SPC Weekly Status Change Report.pdf'
  }
}

export const getImage = id => {
  const folder = helpMap.folder
  const helpObj = helpMap[id]
  if (isEmpty(helpObj)) return ''
  const image = helpObj.image
  if (!image) return ''
  return encodeURI(`${folder}${image}`)
}

export const getSample = id => {
  const folder = helpMap.folder
  const helpObj = helpMap[id]
  if (isEmpty(helpObj)) return ''
  let sample = helpObj.sample
  if (!sample) return ''
  return {
    fileName: sample,
    url: encodeURI(`${folder}${sample}`)
  }
}
